import { useGetSubscriptionQuery } from '../services/SubscriptionService';

const useFetchSubscription = (organizationId) => {
  const { data, error, isLoading } = useGetSubscriptionQuery(organizationId);
  return { data, error, isLoading };
};

export default useFetchSubscription;
